import { render } from "./Incomes.vue?vue&type=template&id=87a5687e&scoped=true"
import script from "./Incomes.vue?vue&type=script&lang=js"
export * from "./Incomes.vue?vue&type=script&lang=js"

import "./Incomes.vue?vue&type=style&index=0&id=87a5687e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-87a5687e"

export default script